window.customElements.define("layout-toggle", class GridToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onButtonClick.bind(this));

    // matchmedia event to change icon and grid layout

    const mediaQuery = window.matchMedia('(min-width: 750px)');
    mediaQuery.addEventListener('change', (e) => {
      if (e.matches) {
        if (this.gridContainer.dataset.layoutDesktop == "standard-grid") {
          this.standardGridIcon.classList.add('active');
          this.smallGridIcon.classList.remove('active');
        } else {
          this.smallGridIcon.classList.add('active');
          this.standardGridIcon.classList.remove('active');
        }
      } else {
        if (this.gridContainer.dataset.layoutMobile == "standard-grid") {
          this.standardGridIcon.classList.add('active');
          this.smallGridIcon.classList.remove('active');
        } else {
          this.smallGridIcon.classList.add('active');
          this.standardGridIcon.classList.remove('active');
        }
      }
    });


    this.gridContainer = document.querySelector('#ProductGridContainer');
    this.standardGridIcon = this.querySelector('#standardGridViewButton');
    this.smallGridIcon = this.querySelector('#smallGridViewButton');
    this.defaultDesktopView = this.gridContainer.dataset.layoutDesktop;
    this.defaultMobileView = this.gridContainer.dataset.layoutMobile;
    this.gridViewDesktop = localStorage.getItem("layout-grid-option-desktop");
    this.gridViewMobile = localStorage.getItem("layout-grid-option-mobile");


    if (this.gridViewDesktop == "standard-grid" && this.defaultDesktopView == "small-grid" && window.innerWidth >= 750) {
      this.click();
      this.gridContainer.dataset.layoutDesktop = "standard-grid";
      this.standardGridIcon.classList.add('active');
      this.smallGridIcon.classList.remove('active');
    }
    if (this.gridViewDesktop == "small-grid" && this.defaultDesktopView == "standard-grid" && window.innerWidth >= 750) {
      this.click();
      this.gridContainer.dataset.layoutDesktop = "small-grid";
      this.smallGridIcon.classList.add('active');
      this.standardGridIcon.classList.remove('active');
    }
    if (this.gridViewMobile == "standard-grid" && this.defaultMobileView == "small-grid" && window.innerWidth < 750) {
      this.click();
      this.gridContainer.dataset.layoutMobile = "standard-grid";
      this.standardGridIcon.classList.add('active');
      this.smallGridIcon.classList.remove('active');
    }
    if (this.gridViewMobile == "small-grid" && this.defaultMobileView == "standard-grid" && window.innerWidth < 750) {
      this.click();
      this.gridContainer.dataset.layoutMobile = "small-grid";
      this.smallGridIcon.classList.add('active');
      this.standardGridIcon.classList.remove('active');
    }

  }

  onButtonClick(event) {
    event.preventDefault();
    console.log('click')

    if(window.innerWidth >= 750) {
      if (this.gridContainer.dataset.layoutDesktop == "standard-grid") {
        console.log('change')
        this.gridContainer.dataset.layoutDesktop = "small-grid";
        localStorage.setItem("layout-grid-option-desktop", "small-grid");
        this.smallGridIcon.classList.add('active');
        this.standardGridIcon.classList.remove('active');
      } else {
        this.gridContainer.dataset.layoutDesktop = "standard-grid";
        localStorage.setItem("layout-grid-option-desktop", "standard-grid");
        this.standardGridIcon.classList.add('active');
        this.smallGridIcon.classList.remove('active');
      }
    } else {
      if (this.gridContainer.dataset.layoutMobile == "standard-grid") {
        this.gridContainer.dataset.layoutMobile = "small-grid";
        localStorage.setItem("layout-grid-option-mobile", "small-grid");
        this.smallGridIcon.classList.add('active');
        this.standardGridIcon.classList.remove('active');
      } else {
        this.gridContainer.dataset.layoutMobile = "standard-grid";
        localStorage.setItem("layout-grid-option-mobile", "standard-grid");
        this.standardGridIcon.classList.add('active');
        this.smallGridIcon.classList.remove('active');
      }
    }
  }
});